import { publicIpfsUrl } from "./constants";

type RowWithLink = { ipfs_link?: string };

/** Extract CID from ipfs.io, gateways, or ipfs:// */
export function extractIpfsCid(link: string | undefined): string | null {
  if (!link || typeof link !== "string") return null;
  const trimmed = link.trim();
  const ipfsProto = trimmed.match(/^ipfs:\/\/([^/?#]+)/i);
  if (ipfsProto) return ipfsProto[1];
  const pathMatch = trimmed.match(/\/ipfs\/([^/?#]+)/);
  if (pathMatch) return pathMatch[1];
  return null;
}

/** Public gateway (ipfs.io) for all records */
export function getIpfsHrefForRecord(row: RowWithLink): string {
  const cid = extractIpfsCid(row.ipfs_link);
  if (!cid) return row.ipfs_link?.trim() || "#";
  return `${publicIpfsUrl}/${cid}`;
}
